export const WALLET_APIS = {
  get_progress: "host/flag/progress",
  ledger: "payments/wallet/ledger",
  settlement: "payments/wallet/settlement",
  recharge: "payments/wallet/recharge",
  recharge_status: "payments/wallet/topup/status",
  withdrawal: "payments/wallet/withdraw",
  retry_settlement: "payments/wallet/settlement/retry",
};

export const WALLET_APIS_PATHNAMES = {
  recharge_status: (order_id) => `${WALLET_APIS.recharge_status}/${order_id}`,
};
